import { Component, type OnInit, Input } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import { NGXLogger } from 'ngx-logger'
import { DataService } from '../../../../services/data.service'
import {
  type EquipmentDTO, VehicleDTOExtended
} from '../../../../services/vehicles.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-revolution-vehicle-equipment',
  standalone: true,
  templateUrl: './vehicle-equipment.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class VehicleEquipmentComponent implements OnInit {
  user: User
  basicEquipment: EquipmentDTO[] = []
  additionalEquipment: EquipmentDTO[] = []
  vehicleDetailed: VehicleDTOExtended

  // serviceKm: number

  sub = {
    onLanguageChangeSub: null,
    onVehicleDetailsLoadedSub: null,
    onVehicleFrequentDriverLoadedSub: null
  }

  @Input()
  public loading: boolean

  licensePlateMask
  constructor (
    public dialog: MatDialog,
    private readonly dataService: DataService,
    private readonly logger: NGXLogger
  ) {
    this.dataService.onUserLoaded.subscribe(user => {
      this.user = user
    })
  }

  @Input()
  public vehicle: VehicleDTOExtended

  ngOnInit (): void {
    this.sub.onVehicleDetailsLoadedSub =
      this.dataService.onVehicleDetailsLoaded.subscribe(vehicleDetails => {
        this.vehicleDetailed = vehicleDetails
        this.basicEquipment = []
        this.additionalEquipment = []
        if (this.vehicleDetailed?.details?.equipment?.[0] != null) {
          this.basicEquipment =
            this.vehicleDetailed?.details.equipment.filter(el => {
              return el.type === 'S'
            })
          if (this.basicEquipment == null) {
            this.basicEquipment = []
          }

          this.additionalEquipment =
            this.vehicleDetailed?.details.equipment.filter(el => {
              return el.type !== 'S'
            })
          if (this.additionalEquipment == null) {
            this.additionalEquipment = []
          }
        }

        if (
          vehicleDetails != null &&
          vehicleDetails?.vin === this.vehicle?.vin
        ) {
          // need to update main vehicle propertys
          Object.keys(vehicleDetails).forEach(key => {
            this.vehicle[key] = vehicleDetails[key]
          })
        }
      })
  }
}
